import genererContactTiersObject from '@/services/tiers/genererContactTiers';

export function fillContactTiersWithData(contactTiers, ligne, tiers, contacts) {
  const errors = [];

  const tier = tiers.find(t => t.referenceExterne === ligne.tiersId);
  contactTiers.tiersId = tier.id;
  const contact = contacts.find(t => t.referenceExterne === ligne.contactId);
  contactTiers.contactId = contact.id;

  if (errors.length > 0) throw errors;
  return contactTiers;
}

export default function genererContactTiers(ligne, tiers, contacts) {
  const contactTiers = genererContactTiersObject();
  return fillContactTiersWithData(contactTiers, ligne, tiers, contacts);
}
